import { useAppSelector } from "../../../Redux/hooks";

import ProfileContentWrapper from "./ProfileContentWrapper";
// import HealthContentWrapper from "./HealthData/HealthContentWrapper";
// import ExerciseContentWrapper from "./Exercise/ExerciseContentWrapper";
// import LearnContentWrapper from "./Learn/LearnContentWrapper";

const TabsContentSelector = ({
  showDownloadModal,
  setShowDownloadModal,
}: any) => {
  const type = useAppSelector((state) => state.participantTab.categoryType);

  switch (type) {
    case "patient_profile":
      return (
        <ProfileContentWrapper
          showDownloadModal={showDownloadModal}
          setShowDownloadModal={setShowDownloadModal}
        />
      );
    // case "health_data":
    //   return <HealthContentWrapper />;
    // case "exercises":
    //   return <ExerciseContentWrapper />;
    // case "learn":
    //   return <LearnContentWrapper />;
    default:
      return null;
  }
};

export default TabsContentSelector;
